const uploadType = {
  DESTINATION_CHARGE_UPLOAD: 'destination_charges_upload',
  SOURCE_CHARGE_MASTER_UPLOAD: 'source_charge',
  PRE_PLAN_MATERIAL: 'preplan_materials',
  ADVANCE_SHIPMENT_NOTICE: 'advance_shipment_notice',
  SHARE_OF_BUSINESS: 'share_of_business',
  SURGE_THRESHOLD_UPLOAD: 'surge_threshold_upload',
  USER_ASSOCIATE_MATERIAL_UPLOAD: 'user_associate_material_upload',
  BASE_FUEL_RATE: 'base_fuel_rate',
  LR_BULK_UPLOAD: 'lr_bulk_upload',
  LAST_MILE_DELIVERY_PICKLIST: 'last_mile_delivery_picklist',
  FREIGHT_ZONE_MASTER_UPLOAD: 'freight_zone',
  DETENTION: 'detention',
};

module.exports = { uploadType };
